export const HERO_HEADLINE = 'Local History Lives Here.';
export const HERO_LEAD = 'Search for historic properties, districts, and buildings to discover the stories hidden behind their walls.';
export const HERO_SEARCH_LABEL = 'Search historic places';
export const HERO_SEARCH_PLACEHOLDER = 'Enter an address to get started.';
export const HERO_IMAGES = [
    { src: '/images/landing/hero/stories.jpg', position: 'center 40%' },
    { src: '/images/landing/hero/district.jpg', position: 'center 35%' },
    { src: '/images/landing/hero/your-house.jpg', position: 'center 45%' },
];
export const HERO_SLIDE_INTERVAL_MS = 7000;
// ─── Pills ──────────────────────────────────────────────────────────────────
export const HERO_EXPLORE_LABEL = 'Explore';
export const HERO_PAGE_PILLS = [
    { label: 'Stories', icon: 'bi-book', page: 'stories' },
    { label: 'Photos', icon: 'bi-images', page: 'photos' },
];
